import { get } from 'lodash';

import Model from 'models';

const MasterProduct = class extends Model {
  get handle() {
    return get(this._data, 'handle');
  }

  get name() {
    return get(this._data, 'name');
  }

  get colorways() {
    return get(this._data, 'colorways');
  }

  get tagLine() {
    return get(this._data, 'tagLine');
  }

  get lifestyleImageUrl() {
    return get(this._data, ['lifestyleImage', 'src']);
  }

  get lifestyleCaption() {
    return get(this._data, 'lifestyleCaption');
  }

  /**
   * The fields below are getting deprecated soon
   */

  get productsSortOrder() {
    return get(this._data, 'productsSortOrder');
  }

  get hasStoryCard() {
    return get(this._data, ['storyCard'], null) !== null;
  }

  get storyCardVideoSrc() {
    return get(this._data, ['storyCard', 'video', 'file', 'url']);
  }

  get storyCardVideoThumbnailSrc() {
    return get(this._data, ['storyCard', 'videoThumbnail', 'file', 'cloudinaryUrl']);
  }

  get storyCardDescription() {
    return get(this._data, ['storyCard', 'description']);
  }

  get storyCardActionText() {
    return get(this._data, ['storyCard', 'actionText']);
  }
};

export default MasterProduct;
